import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { AuthConfig } from '../config/config.contract';

@Injectable()
export class SecurityConfigService {

  constructor(private config: ConfigService) {
  }

  get OktaConfig() {

    if (this.config.appConfig && this.config.appConfig.auth) {
      return {
        baseUrl: this.config.appConfig.auth.orgUrl,
        clientId: this.config.appConfig.auth.clientId,
        redirectUri: this.config.appConfig.auth.redirectUrl,
        logo: this.config.appConfig.logo,
        authParams: {
          issuer: this.config.appConfig.auth.issuer,
          authorizeUrl: this.config.appConfig.auth.authorizeUrl,
          scopes: this.config.appConfig.auth.scope,
          responseType: ['id_token', 'token']
        }
      };
    }

    return null;
  }

  get OktaConfigDefault() {
    return {
        baseUrl: 'https://bio-rad.oktapreview.com',
        clientId: 'client',
        redirectUri: 'http://localhost',
        logo: 'assets/images/logo.png',
        authParams: {
          issuer: 'https://bio-rad.oktapreview.com',
          authorizeUrl: 'https://bio-rad.oktapreview.com'
        }
      };
  }

}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/security/security-config.service.ts